import { Box, Title } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import { InputItem } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/InputItem'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  forms: Form[]
  employee?: Employee
}

const CustomFields = ({ forms, employee }: Props) => (
  <Box paddingTop="s24">
    <Title
      variant="400"
      illustration="user-edit"
      title={i18n.t('settings.custom_fields.title')}
      description={i18n.t('settings.custom_fields.description')}
    />
    {forms.map((form, key) => {
      return (
        <FormRow key={key}>
          <InputItem form={form} currency={employee?.attributes.legal_entity_currency} />
        </FormRow>
      )
    })}
  </Box>
)

export default observer(CustomFields)
